import dayjs from "dayjs";

export const computeStartAndEndOfWeek = (date: dayjs.Dayjs) => {
  const startOfWeek = date.startOf("isoWeek");
  const endOfWeek = date.endOf("isoWeek");

  return { endOfWeek, startOfWeek };
};
